import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface ICaraEntryPoint {
  readonly id: string;
  readonly type: MESSAGES.CARA_ENTRY_POINT;
  readonly nodeId: string;
  readonly rm: boolean;
  readonly role: ROLE.BOT;
  readonly avatar: boolean;
}

export const createCaraEntryPoint = (data: {
  id?: string;
  _id?: string;
  nodeId?: string;
}): ICaraEntryPoint => ({
  id: data.id ?? data._id ?? uuid(),
  type: MESSAGES.CARA_ENTRY_POINT,
  nodeId: data.nodeId ?? '',
  rm: false,
  role: ROLE.BOT,
  avatar: true,
});
